import React from "react";
import ProjectDetailsHeader from "../../components/projects/project-details/ProjectDetailsHeader";
import { Col, Container, Row } from "react-bootstrap";
import RightDetails from "../../components/projects/project-details/RightDetails";
import LeftDetailsCard from "../../components/projects/project-details/LeftDetailsCard";

const ProjectDetails = () => {
  return (
    <div  style={{ padding: "6px", background: "#f8f9fa", height: "100vh" }} >
      <ProjectDetailsHeader />
       <Container fluid className="mt-3">
      <Row className="g-3">
        {/* LEFT */}
        
        <Col xxl={3} xl={4} lg={4} md={12}>
          <LeftDetailsCard />
        </Col>

        {/* RIGHT */}
        <Col xxl={9} xl={8} lg={8} md={12}>
          <RightDetails />
        </Col>
      </Row>
    </Container>
    </div>
  );
};

export default ProjectDetails;
